import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import OtpInput from 'react-otp-input';
import styles from './email-verify.module.css';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../interceptor/intercetptor-inctence";
import Loader from "../Layout/Loader";
import { useTranslation } from "react-i18next";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import assets5 from '../../src/assets/images/login/Asset-5.png';
import coatOfArms from '../../src/assets/images/login/Coat_of_arms_of_Zimbabwe.png';
import { useLoader } from "../_helper/LoaderContext";
import { secureApiRequest } from "../Services/secureApiRequest";
import { decryptResponseData } from "../Services/decryptApiResponse";

const ResetPassword = () => {
    const { _id: resetToken } = useParams();
    const { setLoading } = useLoader();
    // const location = useLocation();
    // const email = location.state?.email;

    const history = useNavigate();
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [toggleNewPassword, setToggleNewPassword] = useState(false);
    const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
    const [otp, setOtp] = useState("");
    // const [otpError, setOtpError] = useState("");

    useEffect(() => {
        if (!resetToken) {
            history(`${process.env.PUBLIC_URL}/forgot-password`);
        } else {
            // console.log('token: ' + _id);
            // localStorage.setItem('doctorAuthToekn', _id)
            // setResetToken(token);
        }
    }, [resetToken, history]);

    const [containerHeight, setContainerHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setContainerHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        setPasswordError(""); // Clear password error when user types
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setConfirmPasswordError(""); // Clear confirm password error when user types
    };

    const toggleNewPasswordVisibility = () => {
        setToggleNewPassword(!toggleNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setToggleConfirmPassword(!toggleConfirmPassword);
    };

    const validateFields = () => {
        let isValid = true;
        // if (!otp) {
        //     setOtpError("Otp is required");
        //     isValid = false;
        // }
        // Password validation
        if (!newPassword) {
            setPasswordError("newPasswordRequired");
            isValid = false;
        } else if (newPassword.length < 8) {
            setPasswordError("passwordLengthRequirement");
            isValid = false;
        }
        if (!confirmPassword) {
            setConfirmPasswordError("reEnterNewPassword");
            isValid = false;
        } else if (newPassword !== confirmPassword) {
            setConfirmPasswordError("passwordsDoNotMatch");
            isValid = false;
        }
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form submission
        if (validateFields()) {
            // Perform login or other actions if fields are valid
            // For example, navigate to another page
            const body = {
                // otp: otp,
                newPassword: newPassword,
                // confirm_password: confirmPassword
            }
            try {
                setLoading(true);
                const response = await axiosInstance.post(`healthcare_providers/auth/changeForgotPassword`, body,
                    {
                        headers: {
                            Authorization: `Bearer ${resetToken}`,
                        },
                    }
                )
                // const response = await secureApiRequest("patch", `clinic_admin/auth/reset-password/${_id}`, body)
                // const dec_data = decryptResponseData(response);
                const dec_data = response.data;
                if (dec_data.status === "success") {
                    toast.success(dec_data.message, {
                        autoClose: 1000, // Display toast for 2 seconds
                        onClose: () => {
                            history(`${process.env.PUBLIC_URL}/login`);
                        }
                    });
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        }
    };

    const resentLink = async () => {
        if (!resetToken) {
            toast.warning("Reset Token not found. Please try again.");
            return;
        }
        try {
            setLoading(true);
            const response = await axiosInstance.post(`healthcare_providers/auth/resendLink`,'',
                {
                    headers: {
                        Authorization: `Bearer ${resetToken}`,
                    },
                }
            );
            // const response = await secureApiRequest("get", `/clinic_admin/auth/resend/otp/${_id}`);
            // const dec_data = decryptResponseData(response);
            const dec_data = response.data;
            if (dec_data.status === 'success') {
                toast.success(dec_data.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            // End loading
            setLoading(false);
        }
    }

    const forgotPassword = () => {
        history(`${process.env.PUBLIC_URL}/forgot-password`);
    };

    return (
        <Fragment>
            <div className="login-page">
                <Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
                    <div className="card">
                        <Row>
                            <Col
                                xs="6"
                                className="b-center bg-size d-none d-md-flex flex-column"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderTopLeftRadius: '15px',
                                    borderBottomLeftRadius: '15px',
                                    // padding: '20px',
                                    color: '#1B245B', // Ensures text is white on the dark background
                                }}
                            >
                                <div style={{ marginLeft: "10%" }}>
                                    <Image
                                        attrImage={{
                                            className: 'login-logo-style',
                                            src: `${logoDark}`,
                                            alt: 'CLINICDOTS Logo',
                                        }}
                                    />
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '0px' }}>CLINICDOTS</h3>
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '20px' }}>HEALTHCARE</h3>
                                    <span>{t("Innovating Healthcare for India.")}</span>
                                </div>
                            </Col>

                            <Col xs="12" md="6"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    // borderTopLeftRadius: '15px',
                                    // borderBottomLeftRadius: '15px',
                                    minHeight: `${containerHeight * 0.94}px`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                <div className='login-card' style={{ flex: '1' }}>
                                    <div className="login-form-responsive">
                                        <Form className="theme-form login-form" onSubmit={handleSubmit}>
                                            {/* This image will only be visible on mobile screens */}
                                            <Image
                                                attrImage={{
                                                    className: 'login-dark-logo-style d-block d-md-none',
                                                    src: `${logoDark}`,
                                                    alt: 'CLINICDOTS Logo',
                                                }}
                                            />
                                            <H4><strong className="mb-3">{t("resetPassword")}</strong></H4>

                                            {/* <FormGroup style={{ marginTop: "2rem" }}>
                                                <Label className="col-form-label">{t("enterOtp")}</Label>
                                                <OtpInput
                                                    value={otp} containerStyle={{ justifyContent: 'space-around' }} inputStyle={`${styles.formControl}`}
                                                    onChange={setOtp}
                                                    numInputs={6}
                                                    shouldAutoFocus={true}
                                                    inputType={'tel'}
                                                    renderSeparator={<span>&nbsp;</span>}
                                                    renderInput={(props) => <input {...props} />}
                                                />
                                                {otpError && <div className="text-danger">{otpError}</div>}
                                            </FormGroup> */}

                                            <FormGroup>
                                                <Label className="col-form-label">{t("newPassword")}</Label>
                                                <div className="position-relative">
                                                    <Input
                                                        placeholder={t("enterNewPassword")} className="form-control pl-5" autoComplete="new-password" type={toggleNewPassword ? "text" : "password"} onChange={handleNewPasswordChange} value={newPassword}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={toggleNewPasswordVisibility}
                                                    >
                                                        <i style={{ fontSize: "x-large" }} className={`fa ${toggleNewPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                {passwordError && <div className="text-danger">{t(passwordError)}</div>}
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="col-form-label">{t("reEnterPassword")}</Label>
                                                <div className="position-relative">
                                                    <Input
                                                        className="form-control pl-5"
                                                        type={toggleConfirmPassword ? "text" : "password"}
                                                        placeholder={t("reEnterPassword")}
                                                        onChange={handleConfirmPasswordChange}
                                                        value={confirmPassword}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={toggleConfirmPasswordVisibility}
                                                    >
                                                        <i style={{ fontSize: "x-large" }} className={`fa ${toggleConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                {confirmPasswordError && <div className="text-danger">{t(confirmPasswordError)}</div>}
                                            </FormGroup>
                                            <div className="position-relative form-group mb-0">
                                                <Btn attrBtn={{ color: "primary", className: "d-block w-100 login-button" }}>{t("resetPassword")}</Btn>
                                            </div>
                                            <p className="my-3 text-center"><strong style={{ color: "#1b255b", cursor: "pointer" }} onClick={resentLink}><u>{t("resendLink")}</u></strong></p>
                                            <p className="my-3 text-center">{t("backTo")} <strong style={{ color: "#1b255b", cursor: "pointer" }} onClick={forgotPassword}>{t("forgotPassword")}</strong></p>
                                        </Form>
                                    </div>
                                </div>
                                {/* <div className="mx-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <small style={{ marginRight: 'auto' }}>
                                    {t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
                                </small>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <Image
                                        attrImage={{
                                            className: 'mb-4 login-footer-logo',
                                            src: `${assets5}`,
                                            alt: 'Assets 5 Logo',
                                        }}
                                    />
                                    <Image
                                        attrImage={{
                                            className: 'mb-4 login-footer-logo',
                                            src: `${coatOfArms}`,
                                            alt: 'Coat Of Arms Logo',
                                        }}
                                    />
                                </div>
                            </div> */}
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <ToastContainer />
        </Fragment>
    );
};

export default ResetPassword;
